// extracted by mini-css-extract-plugin
export default {"loader":"Loading_loader__VhWW1","absolute":"Loading_absolute__Kykz+","top":"Loading_top__h3HBX"};